import { Component, ViewChild, ElementRef } from '@angular/core';
import { fromEvent as observableFromEvent } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

import { DialogPage } from '../../../../lib/common/common.data';
import { AccessKeyInfo } from '../../../../API/v1/Account/api.accessKey.common';
import { IAccessKeyFunc } from '../accessKey-func.service';
import { AccessKeyService } from '../accessKey.service';
import { VirtualDlgComponent } from 'app/content/virtual/dlg/virtual-dlg.component';
import { AccountService } from 'app/entry/account.service';

@Component({
    templateUrl: './acckey-dlg-remove.component.html',
    styleUrls: ['../accessKey.style.css']
})
export class AccessKeyDlgRemoveComponent extends VirtualDlgComponent implements IAccessKeyFunc {
    readonly DELETE_TEXT: string = 'DELETE';
    title: string;
    key: AccessKeyInfo;
    dialogCompleteHandler?: (result: any) => void;

    _page: DialogPage = DialogPage.action;
    _enumDialogPage: typeof DialogPage = DialogPage;
    _loading: boolean;

    _showInactive: boolean = false; //if to show inactive ui (include inactive result)
    _inactiveRequired: boolean = false; //need to inactive the key first
    _inactiveResult: { isFault: boolean, errorMessage?: string };

    _deleteResult: { isFault: boolean, errorMessage?: string };
    _deleteText: string = '';

    private _deleteInputRef: ElementRef;
    @ViewChild('deleteInput', { static: true })
    set deleteInput(v: ElementRef) {
        if (v) {
            this._deleteInputRef = v;
            const searchElement = this._deleteInputRef.nativeElement;
            const searchInputOb = observableFromEvent(searchElement, 'input');

            searchInputOb.pipe(
                debounceTime(200),
                takeUntil(this._unsubscribe$)
            ).subscribe((e: any) => {
                this._deleteText = e.target.value;
            });
        }
    }

    constructor(protected accountSvc: AccountService, private accKeySvc: AccessKeyService) {
        super(accountSvc);
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (this.key) {
            this._inactiveRequired = this._showInactive = this.key.isAccessKeyEnabled;
        }
    }

    inactiveAcc(): void {
        this._loading = true;
        this.accKeySvc.updateAccessKey(this.key, false).subscribe((res: { isFault: boolean, key: AccessKeyInfo, errorMessage?: string }) => {
            this._inactiveResult = {
                isFault: res.isFault,
                errorMessage: res.errorMessage
            };
            this._loading = false;
            if (!res.errorMessage) {
                this._inactiveRequired = false;
            }
        });
    }

    deleteAcc(): void {
        this._loading = true;
        this.accKeySvc.deleteAccessKey(this.key.accessKeyID).subscribe((res: { isFault: boolean, keyList: AccessKeyInfo[], errorMessage?: string }) => {
            this._deleteResult = {
                isFault: res.isFault,
                errorMessage: res.errorMessage
            };
            this._loading = false;
            this._page = DialogPage.result;
            this.dialogCompleteHandler(this._deleteResult);
        });
    }
}